import classNames from 'classnames'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'

import { MenuIcon } from 'components/ui/Icons'
import Locale from 'services/locale'
import { ConfigType } from 'types'

const Navigation: React.FunctionComponent<NavigationProps> = ({
  handleFocus,
  className,
  config,
  locale,
}: NavigationProps) => {
  return (
    <div className={classNames('Navigation', className)}>
      <button className="Navigation__menu-button" onClick={handleFocus}>
        <MenuIcon />
      </button>
      <ul className="Navigation__container Navigation__container--start">
        {config.menu.map((item) => (
          <NavigationLink key={`link_${item.link}`} to={item.link}>
            <span>{locale.translate(item.text)}</span>
          </NavigationLink>
        ))}
      </ul>
    </div>
  )
}

Navigation.defaultProps = {
  className: '',
}

type NavigationProps = {
  handleFocus?: (event: any) => any
  className?: string
  config: ConfigType
  locale: Locale
}

const NavigationLink: React.FunctionComponent<NavigationLinkProps> = ({
  to,
  exact,
  children,
  ...otherProps
}: NavigationLinkProps) => {
  const match = useMatch({ path: to, end: exact })

  return (
    <li className="Navigation__item">
      <Link
        className={classNames({
          Navigation__link: true,
          'Navigation__link--active': !!match,
        })}
        to={to}
        {...otherProps}
      >
        {children}
      </Link>
    </li>
  )
}

type NavigationLinkProps = {
  to: string
  exact?: boolean
  children: React.ReactNode
}

export default Navigation
